/**
 * ver 0.1
 * author jack
 * props
 * @props {integer} f_div (required) 찜구분(0 : 정보없음, 1 : 제조사, 2 : 수입원, 3 : 브랜드, 4 : 상품, 11 : 미니샵)
 * @props {integer} idx (required)
 * @props {boolean} loadData true / false
 * @props {boolean} selected true / false
 * ex)
 <Zzim f_div={} idx={} loadData={} selected={} />
 */

import React from 'react'
import ZzimLayer from "../layer/zzimLayer"

class Zzim extends React.Component {
    constructor(props) {
        super(props)

        let {f_div, idx, loadData, selected, count, itemInfo, index, pageType, itemCompareList, setItemList} = props
        if (selected === undefined) selected = false
        if (loadData === undefined) loadData = false

        this.state = {
            componentUpdate: true,
            f_div, idx, loadData, selected, count, itemInfo, index, pageType, itemCompareList, setItemList,
            zzimLayer: false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.componentUpdate
    }

    componentDidMount() {
        this.setState({componentUpdate: false})
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (this.state.componentUpdate === true){
            this.setState({componentUpdate: false})
        }
    }
    onZzimLayer(selected) {
        let count = this.props.count
        if (this.state.zzimLayer || this.props.itemInfo) {
            if (!this.props.selected && selected) count ++
            else if (this.props.selected && !selected) count --
        }
        this.setState({
            zzimLayer:!this.state.zzimLayer,
            componentUpdate: true,
            selected:selected,
            count:count
        })
    }

    render() {
        const children = this.props.children
        let zzimClass = "button zzim"
        if (this.state.selected) zzimClass = "button zzim active"

        if (this.props.className !== undefined) {
            if (this.state.selected) zzimClass = this.props.classNameOn
            else zzimClass = this.props.className
        }

        let zzimButtonProps = {
            key:0,
            className: zzimClass,
            onClick:()=>this.onZzimLayer(this.state.selected)
        }

        let zzimLayerProps = {
            key:1,
            selected: this.state.selected,
            f_div: this.state.f_div,
            idx: Number(this.state.idx), // 상품 번호
            index: this.state.index, // 현재 담겨진 상품의 index ex) 0,1,2,3...
            onClose:(r)=>this.onZzimLayer(r),
            itemInfo: this.state.itemInfo, // 현재 상품비교 하단창에 담겨진 상품의 정보
            pageType: this.state.pageType, // 찜하기 페이지 타입 - 1: 상품사양 비교 새창
        }

        return [
            <button type="button" {...zzimButtonProps}>{children}</button>,
            this.state.zzimLayer && <ZzimLayer {...zzimLayerProps} />
        ]
    }
}

export default Zzim



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/zzim.js